import React, { useState, useEffect } from "react";
import { Link, Redirect } from 'react-router-dom';

import {

  Grid,

  Button,

  Typography,

  Paper,

  Table,

  TableHead,

  TableBody,

  TableRow,

  TableCell,

} from "@material-ui/core";
import MomentUtils from "@date-io/moment";

import moment from "moment";

import axios from "axios";

export default function TransactionHistory() {
  const [data, setData] = useState([]);

   
    const fetchData = async () => {
  
      try {
   
        const url = "https://ekyc.chili.mu:9443/api/last5transactions?&agentNbr=" + localStorage.getItem('AgentNumber')+ "&mPin=" + localStorage.getItem('agentpin');
      
        const response = await axios.get(url);
        let datacount = response.data.data || {}
      
             console.log("data--->>",datacount.length)

             if(datacount.includes('errorcode')){
                  setData([])
               }
            else{
              if(datacount.length>0){
                setData(datacount);
               }
               else{
                    setData([]);
               }
            }  
  
      } catch (error) {
  
        console.error("API error:", error);
  
        setData({});
  
      }
  
    };
   
    useEffect(() => {
  
      fetchData(); 
  
    }, []);

    const styles = {
        container: {
          padding: '20px',
        },
        cardContainer: {
          display: 'flex',
          flexWrap: 'wrap',
          gap: '16px',
        },
        card: {
          border: '1px solid #ccc',
          borderRadius: '8px',
          padding: '16px',
        //   width: 'fit-content',
          boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
          marginTop:'20px',
          fontSize:'14px'
        }
      };
   
    
   
    return (
      <div className="Auth-container" style={{ textAlign: 'center' }}>
        
        
        <h3 style={{ color: 'Gray' }}>Transaction History</h3>
        
                <Grid container spacing={3} alignItems="center">
        
        <Grid item xs={12} sm={4}>
        
        <button
            className="button_id"
                      fullWidth  
                      variant="contained"
                      color="primary"
                      style={{ fontSize: 16, width: 120, padding: 10 }}
        >
  
  <Link to="/choosecustomer" className="link1">Back</Link>
        </button>
        </Grid>
        </Grid>

{
          // Using a classic for loop instead of map
          
          (() => {
            const cards = [];
            
           
            if(data.length<=0 ){
             return <div>
                <h4> No Records Found</h4>
              </div>
            }
            else{
              for (let i = 0; i < data.length; i++) { 
                const item = data[i];
                cards.push(
                  <div style={{justifyItems:'center',textAlign:'start'}}>
                  <div key={item.transactionID} style={styles.card}>
                    <label><strong>Transaction ID:</strong> {item.transactionID}</label><br></br>
                    <label><strong>Date:</strong> {item.transDate}</label><br></br>
                    <label><strong>MSISDN:</strong> {item.msisdn}</label><br></br>
                    <label><strong>Recharge Amount:MUR {item.userAmountRecharge/1000}</strong></label><br></br>
                    <label><strong>Balance :MUR {item.dealerBalAfter/1000}</strong></label>
                  </div>
                  </div>
                );
              }
            }
            return cards;
          })()
        }
                    
  
        
        </div>
    );
  
  }